
interface Specification {
  label: string;
  value: string;
}

interface ProductSpecificationsProps {
  specifications: Specification[];
}

export default function ProductSpecifications({ specifications }: ProductSpecificationsProps) {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Technical Specifications</h2>
          <p className="text-lg text-gray-600">
            Detailed technical specifications for our fire pump systems
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl overflow-hidden">
            <div className="bg-red-600 text-white p-6">
              <h3 className="text-xl font-semibold">Fire Pump Set Specifications</h3>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                {specifications.map((spec, index) => (
                  <div key={index} className="flex justify-between items-center py-3 border-b border-gray-200 last:border-b-0">
                    <span className="font-medium text-gray-700">{spec.label}:</span>
                    <span className="text-gray-900 font-semibold">{spec.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Performance Chart */}
          <div className="mt-12 bg-gray-50 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">Performance Range</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-2">10-150</div>
                <div className="text-sm text-gray-600">HP Range</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">40-120</div>
                <div className="text-sm text-gray-600">Head (meters)</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600 mb-2">Custom</div>
                <div className="text-sm text-gray-600">Flow Rate</div>
              </div>
            </div>
          </div>

          {/* Installation Notes */}
          <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
            <div className="flex items-start space-x-3">
              <i className="ri-information-line text-blue-600 text-xl mt-1"></i>
              <div>
                <h4 className="font-semibold text-blue-900 mb-2">Installation Requirements</h4>
                <ul className="text-blue-800 text-sm space-y-1">
                  <li>• Adequate foundation and mounting space required</li>
                  <li>• Electrical supply as per motor specifications</li>
                  <li>• Proper ventilation for diesel-driven units</li>
                  <li>• Professional installation recommended</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
